export default function Footer() {
  return <footer>&copy;{new Date().getFullYear()} by robfrontend</footer>;
}
